import { cn } from '../../utils/cn';
import { PartnershipStatus } from '../../types/partnership';

const STATUS_CONFIG: Record<PartnershipStatus, { bg: string; text: string; tone: string; label: string; tooltip: string }> = {
  of_interest: { bg: 'bg-violet-500/15', text: 'text-violet-300', tone: 'badge-purple', label: 'Of Interest', tooltip: 'Creators/packs leadership wants the team to pursue — not yet contacted' },
  prospecting: { bg: 'bg-blue-500/15', text: 'text-blue-300', tone: 'badge-info', label: 'Prospecting', tooltip: 'Researching and gathering info before outreach' },
  outreach: { bg: 'bg-cyan-500/15', text: 'text-cyan-300', tone: 'badge-accent', label: 'Outreach', tooltip: 'Initial contact has been made' },
  negotiating: { bg: 'bg-amber-500/15', text: 'text-amber-300', tone: 'badge-amber', label: 'Negotiating', tooltip: 'In active discussions about terms' },
  active: { bg: 'bg-green-500/15', text: 'text-green-300', tone: 'badge-success', label: 'Active', tooltip: 'Partnership is live' },
  on_hold: { bg: 'bg-orange-500/15', text: 'text-orange-300', tone: 'badge-orange', label: 'On Hold', tooltip: 'Waiting on something external — different from paused' },
  paused: { bg: 'bg-yellow-500/15', text: 'text-yellow-300', tone: 'badge-warning', label: 'Paused', tooltip: 'Was active, temporarily stopped' },
  declined: { bg: 'bg-red-500/15', text: 'text-red-300', tone: 'badge-danger', label: 'Declined', tooltip: 'Creator or team declined the partnership' },
  ended: { bg: 'bg-gray-500/15', text: 'text-gray-300', tone: 'badge-neutral', label: 'Ended', tooltip: 'Partnership has concluded' },
};

interface PartnershipStatusBadgeProps {
  status: PartnershipStatus;
  size?: 'sm' | 'md';
  className?: string;
}

export const PartnershipStatusBadge = ({
  status,
  size = 'sm',
  className,
}: PartnershipStatusBadgeProps) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.prospecting;

  return (
    <span
      className={cn(
        'badge badge-dot',
        config.tone,
        size === 'md' && 'text-xs px-2.5 py-1',
        className
      )}
      title={config.tooltip}
    >
      {config.label}
    </span>
  );
};

export const getStatusColor = (status: PartnershipStatus) => {
  return STATUS_CONFIG[status] || STATUS_CONFIG.prospecting;
};
